import React from 'react';
import propTypes from 'prop-types';
import { getMessage , getCropBasedMessage } from 'util/locale';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

import { Dropdown } from '@tcc/crate';

const baseString = 'vra-seed-product-selector-brand';
const classString = classNames({
  [`${baseString}`]: true
});
const SeedProductSelectorBrand = ({
  brands,
  onChange,
  searchParams
}) => {
  const cropId = useSelector(getActiveCropId);
  const { brandName: selectedBrand } = searchParams;

  const options = brands.map((brand) => {
    return {
      value: brand.name,
      id: brand.uuid
    };
  });

  return (
    <section className={classString}>
      <Dropdown
        className={`${baseString}__select`}
        label={getMessage('brand')}
        options={options}
        placeholder={getCropBasedMessage({ key:'placeholder-text__search-product', cropId })}
        searchable
        setValue={onChange}
        testId={baseString}
        value={selectedBrand}
      />
    </section>
  );
};

SeedProductSelectorBrand.propTypes = {
  brands: propTypes.array.isRequired,
  isAppMode: propTypes.bool.isRequired,
  onChange: propTypes.func.isRequired,
  searchParams: propTypes.object.isRequired
};
export default SeedProductSelectorBrand;
